import * as React from 'react';

import './edittable-card.css';

interface EdittableCardProps {
  blockId: number,
  onEditClick: (event: React.MouseEvent<HTMLElement>) => void,
  onDeleteClick: (event: React.MouseEvent<HTMLElement>) => void
}

class EdittableCard extends React.Component<EdittableCardProps> {
  constructor(props: EdittableCardProps) {
    super(props);
  }

  public render() {
    return (
      <div className="column is-6 is-centered">
        <div className="card edittable-card">
          <div className="columns is-marginless">
            <div className="column is-12 card-content">
              {this.props.children}
            </div>
          </div>
          
          <div className="columns is-marginless is-centered">
            <div className="column is-12 card-action has-text-right has-text-grey-light">
              <span className="icon"
                  onClick={this.props.onEditClick}
                  data-block-id={this.props.blockId}
              >
                <i className="fas fa-pencil-alt" />
              </span>
              <span className="icon"
                  onClick={this.props.onDeleteClick}
                  data-block-id={this.props.blockId}>
                <i className="fas fa-trash-alt" />
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EdittableCard;


// WEBPACK FOOTER //
// ./src/common/widgets/EdittableCard.tsx